function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("clipPath", {
  id: "p.0"
}, React.createElement("path", {
  d: "m0 0l500.0 0l0 500.0l-500.0 0l0 -500.0z",
  clipRule: "nonzero"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m0 0l500.0 0l0 500.0l-500.0 0z",
  fillRule: "evenodd"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m13.385827 21.22393l473.22833 0l0 344.28345l-473.22833 0z",
  fillRule: "evenodd"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 4,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m13.385827 21.22393l473.22833 0l0 344.28345l-473.22833 0z",
  fillRule: "evenodd"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m21.385826 28.9904l457.22833 0l0 283.9685l-457.22833 0z",
  fillRule: "evenodd"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 3,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m21.385826 28.9904l457.22833 0l0 283.9685l-457.22833 0z",
  fillRule: "evenodd"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m467.4252 365.13733l0 0c0 2.1583252 -1.3469543 4.151245 -3.5296936 5.222473c-2.1827393 1.071228 -4.8667297 1.0566101 -7.0334167 -0.038360596c-2.1667175 -1.0949707 -3.4840393 -3.102417 -3.4520874 -5.2605896l7.007324 0.07647705z",
  fillRule: "evenodd"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m467.4252 365.13733l0 0c0 2.1583252 -1.3469543 4.151245 -3.5296936 5.222473c-2.1827393 1.071228 -4.8667297 1.0566101 -7.0334167 -0.038360596c-2.1667175 -1.0949707 -3.4840393 -3.102417 -3.4520874 -5.2605896l7.007324 0.07647705z",
  fillRule: "evenodd"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m213.50656 464.72394l7.9582825 -99.433075l64.681854 0l7.9582825 99.433075z",
  fillRule: "evenodd"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 3,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m213.50656 464.72394l7.9582825 -99.433075l64.681854 0l7.9582825 99.433075z",
  fillRule: "evenodd"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m127.6168 478.77606l3.5039291 -14.015747l245.37009 0l3.5039368 14.015747z",
  fillRule: "evenodd"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 3,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m127.6168 478.77606l3.5039291 -14.015747l245.37009 0l3.5039368 14.015747z",
  fillRule: "evenodd"
});

var SvgWeb = function SvgWeb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0.0 0.0 500.0 500.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWeb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/web.3f78f0e0.svg";
export { ForwardRef as ReactComponent };